import { Controller } from "@hotwired/stimulus"

// Line Check Test (#18003): while a test call is queued or ringing, reload the
// Turbo Frame that holds its result every few seconds. The reloaded card
// carries its own active value, so polling stops by itself once the call is
// completed or failed (the new card renders with active = false).
export default class extends Controller {
  static values = {
    active: Boolean,
    url: String,
    interval: { type: Number, default: 4000 },
  }

  connect () {
    if (this.activeValue) this.#schedule()
  }

  disconnect () {
    this.#clear()
  }

  refresh () {
    const frame = this.element.closest("turbo-frame")
    if (!frame || !this.urlValue) return

    if (frame.getAttribute("src")) {
      frame.reload()
    } else {
      frame.setAttribute("src", this.urlValue)
    }
  }

  #schedule () {
    this.#clear()
    this.timer = setTimeout(() => this.refresh(), this.intervalValue)
  }

  #clear () {
    if (this.timer) clearTimeout(this.timer)
    this.timer = null
  }
}
